import React, { useState } from "react";
import { useDispatch } from "react-redux";

// Example action (adjust according to your project)
import { addTierList, fetchTierList } from "@/slices/LocationSlice/tierSlice";

const AddTier = ({ optionList }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    title: "",
    // code: "",
    val: "",
    optionType: "",
    // country:"",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "val" || name === "optionType" ? Number(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      title: formData.title,
      translate: { English: formData.title },
    //   code: formData.code,
      val: formData.val,
      optionType: formData.optionType,
      // country:formData.country
    };

    const resp = await dispatch(addTierList(data));

    // Reset form
    if (!resp.error) {
      setFormData({
        title: "",
        // code: "",
        val: "",
        optionType: "",
        // country:""
      });

      dispatch(fetchTierList());
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 p-4 max-w-md mx-auto">
      <input
        type="text"
        name="title"
        placeholder="Title"
        value={formData.title}
        onChange={handleChange}
        className="w-full p-1 border rounded"
        required
      />

      {/* <input
        type="text"
        name="code"
        placeholder="Code"
        value={formData.code}
        onChange={handleChange}
        className="w-full p-1 border rounded"
        required
      /> */}



      <input
        type="number"
        name="val"
        placeholder="Value"
        value={formData.val}
        onChange={handleChange}
        className="w-full p-1 border rounded"
        required
      />
      <select
        className="w-full p-1 border rounded"
        name="optionType"
        value={formData.optionType}
        onChange={handleChange}
      >
        <option value="" disabled>
          Select option type
        </option>
        {optionList?.result?.map((option, i) => (
          <option key={i} value={option.id}>
            {option.title}
          </option>
        ))}
      </select>

      {/* <select className="w-full p-1 border rounded" name="country" value={formData.country}  onChange={handleChange}>
       <option value="" disabled >
                        Select Country
                      </option>
                      {countryList?.result?.map((option, i) => (
                        <option key={i} value={option.id}>
                          {option.title}
                        </option>
                      ))}
      </select> */}
      <button
        type="submit"
        className="w-full bg-[var(--mainCol)] text-white p-2 rounded"
      >
        Add Tier
      </button>
    </form>
  );
};

export default AddTier;
